import axios from "axios";
import host from "../../../../global";
import { candidateAuthHeader } from "../../../../utils/candidateAuth";

/**
 * Create a LiveAvatar FULL Mode session for a given interview.
 * Backend creates the Context (system prompt + opening text) and session token.
 * Returns: { session_token, session_id, candidate_name, num_questions, start_index }
 */
export const createLiveAvatarSession = (interviewId) =>
  axios.post(`${host}/liveavatar/session/create/${interviewId}`, null, {
    headers: candidateAuthHeader(interviewId),
  });

/**
 * Called when session.stopped event fires (clean finish).
 * Backend fetches transcript, runs GPT-4o extraction, scores answers.
 * Returns immediately — scoring runs as background task.
 */
export const completeLiveAvatarSession = (interviewId) =>
  axios.post(`${host}/liveavatar/session/complete/${interviewId}`, null, {
    headers: candidateAuthHeader(interviewId),
  });

/**
 * Called on unclean disconnect (browser close, network drop).
 * Uses sendBeacon so it fires even during page unload.
 * Interview stays "In Progress" — candidate can rejoin.
 */
export const disconnectLiveAvatarSession = (interviewId) => {
  const url = `${host}/liveavatar/session/disconnect/${interviewId}`;
  // fetch with keepalive fires even during page unload and supports headers/method correctly.
  // sendBeacon cannot set Content-Type or auth headers, so we avoid it.
  fetch(url, { method: "POST", keepalive: true, headers: candidateAuthHeader(interviewId) }).catch(() => {});
};

/**
 * Initiate an S3 multipart upload for the candidate recording.
 * Returns: { upload_id, key }
 */
export const initiateLiveAvatarRecording = (interviewId) =>
  axios.post(`${host}/liveavatar/recording/initiate/${interviewId}`, null, {
    headers: candidateAuthHeader(interviewId),
  });

/**
 * Get a presigned PUT URL for one part of the multipart upload.
 * Returns: { presigned_url }
 */
export const getLiveAvatarRecordingPartUrl = (interviewId, uploadId, partNumber) =>
  axios.get(`${host}/liveavatar/recording/part-url/${interviewId}`, {
    params: { upload_id: uploadId, part_number: partNumber },
    headers: candidateAuthHeader(interviewId),
  });

/**
 * Complete the S3 multipart upload — S3 assembles all parts into one file server-side.
 * payload: { upload_id, parts: [{PartNumber, ETag}] }
 */
export const completeLiveAvatarRecording = (interviewId, payload) =>
  axios.post(`${host}/liveavatar/recording/complete/${interviewId}`, payload, {
    headers: candidateAuthHeader(interviewId),
  });
